<template>
  <div class="pagination fw" v-if="artistsTotal>maxArtistsOnPage">
    <div class="pagination-controll pagination-controll-left" v-on:click="prevPage(false, $event)">
      <a class="pagination-controll-link icon-arrow-left pointer">
        <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.289999 5.71C0.198959 5.6149 0.127594 5.50275 0.0799994 5.38C-0.0200186 5.13654 -0.0200186 4.86346 0.0799994 4.62C0.127594 4.49725 0.198959 4.3851 0.289999 4.29L3.29 1.29C3.4783 1.1017 3.7337 0.995909 4 0.995909C4.2663 0.995909 4.5217 1.1017 4.71 1.29C4.8983 1.4783 5.00409 1.7337 5.00409 2C5.00409 2.2663 4.8983 2.5217 4.71 2.71L3.41 4H7C7.26522 4 7.51957 4.10536 7.70711 4.29289C7.89464 4.48043 8 4.73478 8 5C8 5.26522 7.89464 5.51957 7.70711 5.70711C7.51957 5.89464 7.26522 6 7 6H3.41L4.71 7.29C4.80373 7.38296 4.87812 7.49356 4.92889 7.61542C4.97966 7.73728 5.0058 7.86799 5.0058 8C5.0058 8.13201 4.97966 8.26272 4.92889 8.38458C4.87812 8.50644 4.80373 8.61704 4.71 8.71C4.61704 8.80373 4.50644 8.87812 4.38458 8.92889C4.26272 8.97966 4.13201 9.0058 4 9.0058C3.86799 9.0058 3.73728 8.97966 3.61542 8.92889C3.49356 8.87812 3.38296 8.80373 3.29 8.71L0.289999 5.71Z"></path>
        </svg>
      </a>
    </div>

    <div class="pagination-content fw">
      <ul class="pagination-base-list fw" id="id_pager" style="overflow: hidden; white-space: nowrap;">
        <template v-if="snowFirst">
          <li v-on:click="changePage(1, false, $event)" class="pointer">
            1
          </li>
          <li>...</li>
        </template>

        <li v-for="page in range" :class="{ active: page == currentPage  }" v-on:click="changePage(page, false, $event)" class="pointer">
          {{ page }}
        </li>
      </ul>
    </div>

    <div class="pagination-controll pagination-controll-right" v-on:click="nextPage(false, $event)">
      <a class="pagination-controll-link icon-arrow-right pointer">
        <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.289999 5.71C0.198959 5.6149 0.127594 5.50275 0.0799994 5.38C-0.0200186 5.13654 -0.0200186 4.86346 0.0799994 4.62C0.127594 4.49725 0.198959 4.3851 0.289999 4.29L3.29 1.29C3.4783 1.1017 3.7337 0.995909 4 0.995909C4.2663 0.995909 4.5217 1.1017 4.71 1.29C4.8983 1.4783 5.00409 1.7337 5.00409 2C5.00409 2.2663 4.8983 2.5217 4.71 2.71L3.41 4H7C7.26522 4 7.51957 4.10536 7.70711 4.29289C7.89464 4.48043 8 4.73478 8 5C8 5.26522 7.89464 5.51957 7.70711 5.70711C7.51957 5.89464 7.26522 6 7 6H3.41L4.71 7.29C4.80373 7.38296 4.87812 7.49356 4.92889 7.61542C4.97966 7.73728 5.0058 7.86799 5.0058 8C5.0058 8.13201 4.97966 8.26272 4.92889 8.38458C4.87812 8.50644 4.80373 8.61704 4.71 8.71C4.61704 8.80373 4.50644 8.87812 4.38458 8.92889C4.26272 8.97966 4.13201 9.0058 4 9.0058C3.86799 9.0058 3.73728 8.97966 3.61542 8.92889C3.49356 8.87812 3.38296 8.80373 3.29 8.71L0.289999 5.71Z"></path>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
  import ArtistsPaginationMix from "../../../../components/list/ArtistsPaginationMix";

  export default {
    name    : 'artists-paginationsub',
    mixins: [ArtistsPaginationMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_light/components/list/ArtistsPaginationSub.vue